/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { IAttributeListItem, ISearchAssignmentItem } from '../../models';

export interface IAttributeState {
  items: IAttributeListItem[];
  loading: boolean;
  error: boolean;
  selectedAttributes: IAttributeListItem[];
  assignments: ISearchAssignmentItem[];
  assignmentsLoading: boolean;
  assignmentsError: boolean;
  lastSearchedEntityKey: string;
  legacyMapToUuid: Record<string, string>;
  uuidMapToLegacy: Record<string, string>;
}

export const initialAttributeState: IAttributeState = {
  items: [],
  loading: false,
  error: false,
  selectedAttributes: [],
  assignments: [],
  assignmentsLoading: false,
  assignmentsError: false,
  lastSearchedEntityKey: '',
  legacyMapToUuid: {},
  uuidMapToLegacy: {}
};
